import { types } from "../../types/types";

const initialState = {
  cargada: false,
  contadores: null,
  error: null,
  items: [],
  itemsDias: [],
  itemsHoras: [],
  itemsDisponibles: [],
  itemsDiasSobreturno: [],
  loading: false,
  practicas: [],
  seleccionado: null,
  autopercepcionAfi: null,
  pacienteSala: null,
  pacientesEnEspera: []
};

export const agendaReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.agendaTraerStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
      };
    case types.agendaDiasTraerSuccess:
      return {
        ...state,
        loading: false,
        itemsDias: action.payload,
        cargada: true,
      };
    case types.agendaDiasSobreturnosTraerSuccess:
      return {
        ...state,
        loading: false,
        itemsDiasSobreturno: action.payload,
        cargada: true,
      };
    case types.agendaHorariosTraerSuccess:
      return {
        ...state,
        loading: false,
        itemsHoras: action.payload,
        cargada: true,
      };
    case types.agendaTurnosDisponiblesTraerSuccess:
      return {
        ...state,
        loading: false,
        itemsDisponibles: action.payload,
        cargada: true,
      };
    case types.agendaTurnosSeleccionarSuccess:
      return {
        ...state,
        seleccionado: action.payload,
      };
    case types.agendaTurnosLimpiar:
      return {
        ...state,
        loading: false,
        items: [],
        cargada: false,
      };
    case types.agendaTurnosSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        cargada: true,
      };
    case types.agendaContadoresSuccess:
      return {
        ...state,
        loading: false,
        contadores: action.payload,
        cargada: true,
      };
    case types.agendaCancelarTurnoSuccess:
      return {
        ...state,
        loading: false,
        items: state.items.filter((item) => item.idAgenda !== action.payload),
        cargada: true,
      };
    case types.agendaTurnoModificarAsistenciaSuccess:
      return {
        ...state,
        loading: false,
        items: state.items.map((item) =>
          item.idAgenda === action.payload.idAgenda
            ? {
              ...item,
              confirmado: action.payload.confirmado,
            }
            : item
        ),
        cargada: true,
      };
    case types.agendaExentarPagoTurnoSuccess:
      return {
        ...state,
        loading: false,
        items: state.items.map((item) =>
          item.idAgenda === action.payload
            ? {
              ...item,
              exencion: true,
            }
            : item
        ),
        cargada: true,
      };
    case types.agendaTraerError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        items: [],
        itemsDias: [],
        itemsHoras: [],
        contadores: null,
        seleccionado: null,
        itemsDisponibles: [],
        itemsDiasSobreturno: [],
        cargada: false,
      };
    case types.agendaLimpiarDisponibles:
      return {
        ...state,
        loading: false,
        itemsHoras: [],
        seleccionado: null,
        itemsDisponibles: [],
        cargada: false,
      };
    case types.agendaLimpiarSeleccionado:
      return {
        ...state,
        seleccionado: null,
      };
    case types.agendaLimpiarItems:
      return {
        ...state,
        items: [],
      };
    case types.agendaLimpiar:
      return {
        loading: false,
        items: [],
        itemsDias: [],
        itemsHoras: [],
        contadores: null,
        seleccionado: null,
        itemsDisponibles: [],
        itemsDiasSobreturno: [],
        cargada: false,
        practicas: [],
      };
    case types.agendaGetPracticasSuccess:
      return {
        ...state,
        practicas: action.payload,
      };
    case types.agendaGetPracticasError:
      return {
        ...state,
        practicas: [],
      };
    //AUTOPERCEPCION AFILIADO
    case types.agendaAutopercepcionAfiliadoGetSuccess:
      return {
        ...state,
        autopercepcionAfi: action.payload,
      };
    case types.agendaAutopercepcionAfiliadoGetError:
      return {
        ...state,
        autopercepcionAfi: null,
      };
    //PISO Y CONSULTORIO TEST
    case types.agendaSetPisoConsultorioTest:
      return {
        ...state,
        items: state.items.map((item) =>
          item.idAgenda === action.payload.idAgenda
            ? {
              ...item,
              piso: action.payload.piso,
              consultorio: action.payload.consultorio,
            }
            : item
        ),
      };
    case types.agendaGetPacientesEnSalaSuccess:
      return {
        ...state,
        pacienteSala: action.payload,
      };
    case types.agendaGetPacientesEnEsperaSuccess:
      return {
        ...state,
        pacientesEnEspera: action.payload,
      };
    default:
      return state;
  }
};
